import { render, staticRenderFns } from "./LeaveAllowancePolicy.vue?vue&type=template&id=71ea95ec&"
import script from "./LeaveAllowancePolicy.vue?vue&type=script&lang=js&"
export * from "./LeaveAllowancePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports